require('./sentry')
require('./language-switcher')
import Tooltip from 'bootstrap/js/src/tooltip'
import DocumentSign from './document-sign'
import SmsGate from './sms-gate'
import Layout from './layout'
import pdfViewerInit from "./pdf-viewer"
import { expander } from './expander'
document.onreadystatechange = function () {
    if (document.readyState === "interactive") {
        if(document.getElementById('sms-gate-element')) {
            (new SmsGate()).init()
        }
        if(document.getElementById('sign-element')) {
            (new DocumentSign()).sign()
        }
        if(document.getElementById('btn-document-decline')) {
            (new DocumentSign()).decline()
        }

        if(document.getElementById('document-element')) {
            (new Layout()).init()
            pdfViewerInit()
        }

        expander()

        //tooltips
        let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl)
        })

    }
};
